import React, { FC } from "react";
import {
  Backdrop as BackdropMUI,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";

export const Backdrop: FC<{
  open: boolean;
  message?: string;
}> = ({ open, message }) => {
  return (
    <BackdropMUI
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <CircularProgress color="inherit" />
        </Grid>
        {message && (
          <Grid item xs={12}>
            <Typography>{message}</Typography>
          </Grid>
        )}
      </Grid>
    </BackdropMUI>
  );
};
